import type { ClientType } from 'state/secondaryMarket/shared/form.models';
import type { AppState } from 'state/state.model';

function getOriginalForm(state: AppState, tabId: string) {
  return state.secondaryMarket.cpOrder.form.original[tabId];
}

export function getOriginalFormClient(appState: AppState, tabId: string) {
  const form = getOriginalForm(appState, tabId);
  return form?.client;
}

export function isCpOrderToAmendLoaded(state: AppState, tabId: string): boolean {
  return getOriginalForm(state, tabId) !== undefined;
}

export function getOriginalFormETag(state: AppState, tabId: string): string | undefined {
  return getOriginalForm(state, tabId).etag;
}

export function getOriginalFormClientType(state: AppState, tabId: string): ClientType | undefined {
  return getOriginalForm(state, tabId)?.clientType;
}

export function getOriginalFormSettlementType(state: AppState, tabId: string) {
  return getOriginalForm(state, tabId)?.settlementType;
}
